import type { ApiClient } from "../client";

export class BaseService {
	constructor(
		protected _client: ApiClient,
		protected _prefix = "",
	) {}
}
